import { createSlice } from "@reduxjs/toolkit";
import { ReportTemplatesActionTypes, ReportTemplatesState } from "../types/reportTemplatesState.types";
import { REPORT_TEMPLATES_SLICE_NAME } from "../utils/storeUtils";

const initialState: ReportTemplatesState = {
  templates: [],
  companies: [],
};

export const reportTemplatesSlice = createSlice({
  name: REPORT_TEMPLATES_SLICE_NAME,
  initialState,
  reducers: {
    setTemplates: (state, action: ReportTemplatesActionTypes["setTemplates"]) => {
      state.templates = action.payload;
    },
    setCompanies: (state, action: ReportTemplatesActionTypes["setCompanies"]) => {
      state.companies = action.payload;
    },
  },
});

export default reportTemplatesSlice.reducer;
